module.exports = __webpack_public_path__ + "media/images/why-trust-us-6a68c58d91fdeef5eea5a543e06c339e.jpg";